import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
import { LockIcon, ClockIcon } from './icons/Icons';
import { useCountdown } from '../hooks/useCountdown';
const IMAGES = {
  ebook: 'https://cdn.magicpatterns.com/uploads/7T58E3TjTYgiqrvh4HrvYf/G-smart.png',
  // Bonus 1 -> Lista de Compras "Antifuego" (tablet checklist cover)
  bonus1: 'https://cdn.magicpatterns.com/uploads/7eX7SEg8Ef5xRBmfoeci3P/G-B1.png',
  // Bonus 2 -> Recetario "Desayunos Claros"
  bonus2: 'https://cdn.magicpatterns.com/uploads/1R4RaMXoCBwb3VrWcaMPhn/G-b2.png',
  // Bonus 3 -> Batidos de Emergencia (green smoothie cover)
  bonus3: 'https://cdn.magicpatterns.com/uploads/umfT5SpTKCadqLyXyNRyKh/G-b3.png'
};
type Item = {
  tag: string;
  title: string;
  desc: string;
  value: string;
  image: string;
  alt: string;
  featured?: boolean;
};
const items: Item[] = [{
  tag: 'Ebook Maestro',
  title: 'GastroSmart',
  desc: 'El protocolo de 21 días para reconstruir tu estómago paso a paso.',
  value: '$97',
  image: IMAGES.ebook,
  alt: 'Ebook Maestro GastroSmart mostrado en una tablet',
  featured: true
}, {
  tag: 'Bonus 1',
  title: 'Lista de Compras “Antifuego”',
  desc: 'Ve directo a lo que sana y ahorra dinero en el supermercado.',
  value: '$37',
  image: IMAGES.bonus1,
  alt: 'Lista de Compras Antifuego mostrada en una tablet sobre una mesa de madera'
}, {
  tag: 'Bonus 2',
  title: 'Recetario “Desayunos Claros”',
  desc: 'Empieza cada día sin acidez con 20 desayunos que sanan.',
  value: '$47',
  image: IMAGES.bonus2,
  alt: 'Portada del recetario 20 Desayunos que Sanan'
}, {
  tag: 'Bonus 3',
  title: 'Batidos de Emergencia',
  desc: 'Tu extintor personal para los ataques agudos de ardor.',
  value: '$27',
  image: IMAGES.bonus3,
  alt: 'Portada del ebook Batidos de Emergencia con un batido verde'
}];
export function OfferSection() {
  const {
    minutes,
    seconds
  } = useCountdown(14 * 60 + 59);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="oferta" className="w-full scroll-mt-20 bg-[#1f2a22] py-16 text-white sm:py-20" data-id="element-184">
      <div className="mx-auto max-w-6xl px-5" data-id="element-185">
        <Reveal data-id="element-186">
          <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-[#7fbf74]" data-id="element-187">
            Todo lo que recibes hoy
          </p>
          <h2 className="mx-auto mt-2 max-w-2xl text-center font-display text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-188">
            Por menos de lo que cuesta una pizza
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-189">
          {items.map((item, i) => <Reveal key={item.title} delay={i * 0.08} className={item.featured ? 'sm:col-span-2' : ''} data-id="element-190">
              <div className={`flex h-full items-center gap-5 rounded-2xl p-5 ${item.featured ? 'border-2 border-[#7fbf74] bg-[#26332a]' : 'border border-white/10 bg-white/[0.04]'}`} data-id="element-191">
                <div className="relative shrink-0" data-id="element-192">
                  <img src={item.image} alt={item.alt} className={`rounded-lg object-cover shadow-lg ${item.featured ? 'h-32 w-24 sm:h-40 sm:w-32' : 'h-24 w-24 sm:h-28 sm:w-28'}`} data-id="element-193" />
                </div>
                <div className="min-w-0 flex-1" data-id="element-194">
                  <span className={`inline-block rounded-md px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${item.featured ? 'bg-[#7fbf74] text-[#1f2a22]' : 'bg-[#e0611f]/20 text-[#ff9a5f]'}`} data-id="element-195">
                    {item.tag}
                  </span>
                  <h3 className="mt-1.5 font-display text-lg font-extrabold leading-tight sm:text-xl" data-id="element-196">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm text-white/70" data-id="element-197">{item.desc}</p>
                  <p className="mt-2 text-sm font-semibold text-white/50" data-id="element-198">
                    Valor <span className="line-through" data-id="element-199">{item.value}</span>
                  </p>
                </div>
              </div>
            </Reveal>)}
        </div>

        {/* Price stack */}
        <Reveal delay={0.15} data-id="element-200">
          <div className="mx-auto mt-10 max-w-xl rounded-3xl bg-white p-7 text-center text-[#1f2a22] shadow-2xl sm:p-9" data-id="element-201">
            <div className="flex items-center justify-center gap-3 text-[#5a6b5c]" data-id="element-202">
              <span className="text-base font-medium" data-id="element-203">Valor Total</span>
              <span className="font-display text-2xl font-bold text-[#7a1e12] line-through decoration-2" data-id="element-204">
                $208.00
              </span>
            </div>

            <div className="my-4 flex items-center justify-center gap-2" data-id="element-205">
              <span className="h-px flex-1 bg-[#1f2a22]/10" data-id="element-206" />
              <span className="text-xs font-semibold uppercase tracking-widest text-[#3f6b3a]" data-id="element-207">
                Precio hoy
              </span>
              <span className="h-px flex-1 bg-[#1f2a22]/10" data-id="element-208" />
            </div>

            <motion.div initial={{
            scale: 0.9
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 12
          }} className="font-display text-6xl font-black text-[#e0611f] sm:text-7xl" data-id="element-209">
              $10.99
            </motion.div>
            <p className="mt-1 text-sm font-medium text-[#5a6b5c]" data-id="element-210">
              Pago único · acceso de por vida
            </p>

            <div className="mt-6" data-id="element-211">
              <CtaButton data-id="element-212" />
            </div>

            <div className="mt-4 flex flex-col items-center justify-center gap-2 text-xs text-[#5a6b5c] sm:flex-row sm:gap-5" data-id="element-213">
              <span className="flex items-center gap-1.5" data-id="element-214">
                <LockIcon className="h-4 w-4 text-[#3f6b3a]" strokeWidth={2} data-id="element-215" />
                Pago 100% seguro
              </span>
              <span className="flex items-center gap-1.5 font-semibold text-[#7a1e12]" data-id="element-216">
                <ClockIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-217" />
                Expira en {pad(minutes)}:{pad(seconds)}
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}